<template>
    <div class="edit_input">
        <ddHeader :title="$route.params.item.name"></ddHeader>
        <div class="input_contain">
            <div class="submit_contain" v-if="$route.params.item.type!=='gender'">
                <input type="text" v-model="inValue" :placeholder="defaultTxt" v-if="$route.params.item.type!=='desc'">
                <div class="x_icon" @click="clear" v-if="isClear&&$route.params.item.type!=='desc'"></div>
            </div>
            <div class="submit_contain submit_contain_desc " v-if="$route.params.item.type=='desc'">
                <textarea v-model="inValue" :placeholder="defaultTxt"></textarea>
            </div>
            <div class="sex" v-if="$route.params.item.type=='gender'">
                <div class="sex_item" @click="sex=0">
                    <div class="duihao_gray" :class="{duihao_red:this.sex==0}"></div>
                    <span>男</span>
                </div>
                <div class="sex_item" @click="sex=1">
                    <div class="duihao_gray" :class="{duihao_red:this.sex==1}"></div>
                    <span>女</span>
                </div>
            </div>
        </div>
        <div class="save" @click="save">保存</div>
        <popup :pop-obj="errobj" v-if="errobj.type"></popup>
    </div>
</template>
<script>
import ddHeader from './header.vue'
import popup from './popup.vue'    
export default {
    name: 'editInput',
    components: { ddHeader, popup },
    data() {
        return {
            inValue:this.$route.params.item.isEmpty ? '':this.$route.params.item.content,
            urlPara: this.$route.params.item,
            errobj: {
                type: '',
                errorMsg: ''
            },
            isClear:this.$route.params.item.isEmpty ? false : true,
            sex: this.$route.params.item.content ==='男'?0:1,
            defaultTxt:this.$route.params.item.isEmpty ? this.$route.params.item.content : ''
        }
    },
    methods: {
        save() {
            //个人信息
            var urlParaType = this.urlPara.type;
            
            if (urlParaType != 'gender') {
                if(this.inValue == this.$route.params.item.content ){
                    this.errobj = {
                        type: 'pop',
                        errorMsg: '请修改后再提交'
                    }
                    return;
                }
                var regObj = {
                    qq: /^[a-zA-Z0-9_\.\@]{1,50}$/,
                    email: /^[a-zA-Z0-9_\.\@]{1,50}$/,
                    weixin: /^[a-zA-Z0-9_\.\@]{1,50}$/,
                    nickname: /^[\u4e00-\u9fa5a-zA-Z0-9_]{4,20}$/,
                    desc: /^[^\s]{1,200}$/,
                }
                if (!regObj[urlParaType].test(this.inValue)) {
                    if (urlParaType == 'qq' || urlParaType == 'weixin' || urlParaType == 'email') {
                        this.errobj = {
                            type: 'pop',
                            errorMsg: '请输入1-50位英文或数字'
                        }
                    } else if(urlParaType == 'desc'){
                        this.errobj = {
                            type: 'pop',
                            errorMsg: '请输入1-200位英文、中文或数字。'
                        }
                    }else if(urlParaType == 'nickname'){
                        this.errobj = {
                            type: 'pop',
                            errorMsg: '请输入4-20位英文、中文、数字组成的昵称。'
                        }
                    }else {
                        this.errobj = {
                            type: 'pop',
                            errorMsg: '请输入正确的' + this.urlPara.name
                        }
                    }

                    return false
                }

                //昵称长度单独处理
                if(urlParaType == 'nickname'){
                    if(this.inValue.gblen() > 20 ){
                        this.errobj = {
                            type: 'pop',
                            errorMsg: '请输入4-20位英文、中文、数字组成的昵称。'
                        }
                        return false
                    }
                }
                
            } else {
                this.inValue = this.sex;
            }
            this.$http({
                method: 'post',
                url: 'my.php',
                data: {
                    action: 'info_edit',
                    [this.$route.params.item.type]: this.inValue
                }
            }).then((result) => {
                var data = result.data
                if ( data.errorCode == 0  ) {
                    if( urlParaType == 'nickname' ){
                        if(data.status){
                            this.$router.go(-1)
                        }else{
                            this.errobj = {
                                type: 'pop',
                                errorMsg: '失败'
                            }
                            return false
                        }
                    }else{
                         this.$router.go(-1)
                    }
                    this.errobj = {
                        type: 'pop',
                        errorMsg: data.errorMsg || data.errorMessage
                    }
                } else {
                    this.errobj = {
                        type: 'pop',
                        errorMsg: data.errorMsg || data.errorMessage || '失败'
                    }
                }
            }).catch(() => {
                this.errobj = {
                    type: 'pop',
                    errorMsg: '网络错误请稍后重试'
                }
            })
        },
        clear() {
            this.inValue = ''
            this.defaultTxt = ''
            this.isClear = false
        },
        sexSelect(num) {
            this.sex = num
        }

    },
    watch: {
        inValue: function (val) {
            if (val) {
                this.isClear = true
            }
        }
    }
}
</script>
<style lang="stylus">
    .edit_input
        background:#f5f5f5
        height:100%
        overflow:hidden
        .input_contain
            width:100%
            height:100%
            margin-top:.25rem
            .submit_contain
                background:#fff
                padding:0 1rem
                padding-right:2rem
                position:relative
                input
                    width:100%
                    height:2.5rem
                    font-size:.7rem
                    color:#505050
                textarea
                    width:100%
                    height:7.25rem
                    border:none
                    font-size:.7rem
                    color:#505050
                    line-height:1.1rem
                    resize: none
                    padding-top:.5rem
                .x_icon
                    width:1rem
                    height:1rem
                    background:url('../assets/images/x.png') no-repeat
                    background-size:100% 100%
                    position:absolute
                    right:1rem
                    top:50%
                    margin-top:-.5rem
            .submit_contain_desc
                padding-right:1rem
            .sex
                padding:0 .75rem
                background:#fff
                .sex_item
                    padding-left:.2rem
                    height:2.5rem
                    border-bottom 1px solid #ebebeb
                    box-sizing border-box
                    position relative
                    .duihao_gray
                        width 1.15rem
                        height 1.15rem
                        background url('../assets/images/duihao_gray.png') no-repeat
                        background-size 100% 100%
                        position absolute
                        left:.2rem
                        top:50%
                        margin-top -.575rem
                    .duihao_red
                        background url('../assets/images/duihao_red.png') no-repeat
                        background-size 100% 100%
                    span
                        margin-left 2.125rem
                        font-size .65rem
                        color #505050
                        line-height 2.5rem
                .sex_item:last-child
                    border:none
        .save
            width:100%
            height:2.25rem
            background:#ff463c
            color:#fff
            font-size:.75rem
            text-align:center
            line-height:2.25rem
            position:absolute
            left:0
            bottom:0
</style>



// WEBPACK FOOTER //
// editInput.vue?01519252